import { render, staticRenderFns } from "./vue_jqxgrid.vue?vue&type=template&id=4823879f"
import script from "./vue_jqxgrid.vue?vue&type=script&lang=js"
export * from "./vue_jqxgrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports